import React from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { State } from "../../app/store";

// Konfiguracja czatera - mapowanie facilityId -> token
const CZATER_CONFIG = {
  "1239": {
    token: "b4bc1380d72f448b5d2f055861d90e27d30f88e7",
    domain: "https://www.czater.pl/"
  },
  "1246": {
    token: "b4bc1380d72f448b5d2f055861d90e27d30f88e7",
    domain: "https://www.czater.pl/"
  }
} as const;

declare global {
  interface Window {
    $czater?: {
      tok: string;
      domain: string;
      login: undefined;
      email: undefined;
    };
  }
}

const CzaterIntegration: React.FC = () => {
  const facilityIds = useSelector((state: State) => state.config.facilityIds);

  // Sprawdzamy czy current facilityId jest w konfiguracji
  const czaterConfig = CZATER_CONFIG[facilityIds as keyof typeof CZATER_CONFIG];

  if (!czaterConfig) {
    return null; // Nie renderujemy nic dla nieskonfigurowanych facilityIds
  }

  return (
    <Helmet>
      <script>
        {`
          window.$czater = {
            tok: "${czaterConfig.token}",
            domain: "${czaterConfig.domain}",
            login: undefined,
            email: undefined,
          };
        `}
      </script>
      <script src="https://www.czater.pl/assets/modules/chat/js/chat.js" async></script>
    </Helmet>
  );
};

export default CzaterIntegration;